import classNames from "classnames";
import { IconButton } from "@/components/ui/buttons/IconButton";
import { Trash2 } from "lucide-react";
import type { IServiceCustomer } from "@/services";
import styles from "./CustomerListItem.module.css";

export interface CustomerListItemProps {
  customer: IServiceCustomer;
  onDelete?: (customer: IServiceCustomer) => void;
  isDeleting?: boolean;
  deleteLabel?: string;
  className?: string;
  "data-testid"?: string;
}

export function CustomerListItem({
  customer,
  onDelete,
  isDeleting = false,
  deleteLabel = "Slett kunde",
  className,
  "data-testid": testId,
}: CustomerListItemProps) {
  return (
    <div
      className={classNames(styles.container, className)}
      data-testid={testId}
    >
      <div className={styles.customerInfo}>
        <span className={styles.customerName}>{customer.name}</span>
        <span className={styles.customerId}>ID: {customer.id}</span>
      </div>
      {onDelete && (
        <IconButton
          icon={<Trash2 size={16} />}
          aria-label={deleteLabel}
          variant="clear"
          size="sm"
          shape="square"
          onClick={() => onDelete(customer)}
          disabled={isDeleting}
          data-testid={testId ? `${testId}-delete` : undefined}
        />
      )}
    </div>
  );
}

CustomerListItem.displayName = "CustomerListItem";

export default CustomerListItem;
